import * as React from "react";
import "src/styles/flags.css"

export function Flags(props){

	return (
		
		<div className="flags-container">
			<div className="flag-marshall-islands" />
			<div className="flag-iceland" />
			<div className="flag-czech-republic" />
			<div className="flag-greenland"/>
			<div className="flag-panama"/>
			{/* <div className="flag-comoros"/> */}
			{/* <div className="flag-grenada"/> */}
			<div className="flag-nepal"/>
			{/* <div className="flag-maryland"/> */}
			<div className="flag-minnesota"/>
			{/* <div className="flag-antigua-and-barbuda"/> */}
		</div>
	)

}